import { sortBy, get } from 'lodash';

/**
 *
 * @param dataOffer
 */
export const dataOfferTransform = dataOffer => {
  try {
    // get data
    const data = sortBy(get(dataOffer, 'data'), 'sequence');
    const result = {
      ...dataOffer,
      data,
    };

    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(` ${e.stack}`);
  }
  return undefined;
};

/**
 * formulas transform
 * @param {*} formulas
 */
export const formulasTransform = dataOffer => {
  try {
    const formulas = sortBy(get(dataOffer, 'formulas'), 'sequence');
    return formulas;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(` ${e.stack}`);
  }
  return undefined;
};
